import {enumParamType} from '@/models/parameter.model';

/**
 * Représente la structure de données renvoyée par les requêtes suivantes :
 *  - addTerminal (terminal.axios.ts)
 *  - upadateTerminal (terminal.axios.ts)
 */
export interface TerminalDocument {
  _id: string
  prjid: string
  name: string
  location: string
  fordebug: boolean
}

/**
 * Représente la structure de donnée renvoyée par un message WebSocket d'exécution de step
 */
export interface WsStepDataMessage {
  logs: TerminalReportStep
  ctx: [string, any][]
  params: TerminalParam[]
  flagStop: boolean
}

/**
 * Représente la structure des données envoyées au terminal d'automatisation pour l'exécution d'un step
 */
export interface TerminalDataStep {
  pos: number
  istoy: boolean
  lib: string
  fn: string
  parameters: TerminalParam[] // Paramètres des instructions
  config: TerminalParam[] // Mapping Keys des Toys ou Settings des Tools
  toolid?: string
}

export interface TerminalParam {
  key: string
  value: string
  type?: enumParamType
  options?: string[]
}

/**
 * Représente la structure de donnée de reporting de l'exécution d'un step
 * Est utilisé par l'agent du terminal d'exécution
 * - setReport(rdataid: string, pos: number, report: RunReport)
 */
export interface TerminalReportStep {
  pos: number
  runtime: number,
  status: stepStatus,
  messages: TerminalLog[]
}

export interface TerminalLog {level: logLevel, message: string}

export enum stepStatus {
  cancel,
  pass,
  fail
}

export enum logLevel {
  info,
  warning,
  error
}

export interface TerminalVariable {
  name: string
  value: string
}
